// ConfigProduct.js
import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';

// Child pages (paths per your setup)
import VATPage from './components/ConfigVAT';
import Allergens from './components/ConfigAllergens';

const Container = styled(Paper)(({ theme }) => ({
  borderRadius: 16,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  overflow: 'hidden',               // ensures the dark header and body clip; no white sliver
}));

const TabBar = styled(Box)(() => ({
  backgroundColor: '#273442',       // match your table header color
  color: '#fff',
}));

function a11yProps(index) {
  return {
    id: `configproduct-tab-${index}`,
    'aria-controls': `configproduct-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`configproduct-tabpanel-${index}`}
      aria-labelledby={`configproduct-tab-${index}`}
      {...other}
    >
      {value === index && (
        // zero padding so the table header sits flush; avoids the white margin
        <Box sx={{ p: 0 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default class ConfigProduct extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tab: 0 };
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  handleTabChange(e, newValue) {
    this.setState({ tab: newValue });
  }

  render() {
    const { tab } = this.state;

    return (
      <Container elevation={0}>
        {/* Dark header / tabs */}
        <TabBar>
          <Tabs
            value={tab}
            onChange={this.handleTabChange}
            aria-label="Product configuration tabs"
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              px: 1,
              minHeight: 48,
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 600,
                minHeight: 48,
                color: 'inherit',     // use header's white
                opacity: 0.85,
              },
              '& .Mui-selected': {
                opacity: 1,
                color: 'inherit',
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#FFFFFF', // slim white indicator for contrast
                height: 3,
              },
            }}
          >
            <Tab label="VAT" {...a11yProps(0)} />
            <Tab label="Allergens" {...a11yProps(1)} />
          </Tabs>
        </TabBar>

        {/* Body (no extra top padding -> no white strip above Add bar) */}
        <TabPanel value={tab} index={0}>
          <VATPage />
        </TabPanel>

        <TabPanel value={tab} index={1}>
          <Allergens />
        </TabPanel>
      </Container>
    );
  }
}
